<template lang="pug">
  .section-units
    template(v-if="course.units")
      p(v-if="!course.units.length").text-center Темы еще не добавлены...
      v-row(v-else)
        v-col(
          v-for="(unit, idx) in course.units" cols="6"
          :key="idx"
          :class="!isMobile ? 'px-16' : ''"
        )
          v-card.sdo-card.mt-2(height="100%")
            v-card-text.d-flex.flex-column
              v-chip(
                style="position: absolute; right: -3px; top: 0" right="0"
                color="secondary" small
              ): strong {{ idx + 1 }}
              p.title {{ unit.title }}
              v-spacer
              strong {{ $tc('hours', unit.duration) }}

      //- v-carousel(
      //-   v-else
      //-   show-arrows height="100%"
      //-   hide-delimiters :continuous="false"
      //- )
      //-   v-carousel-item.mr-4.pb-2(v-for="(items, slideIdx) in unitItems" :key="idx")
      //-     v-row
      //-       v-col(
      //-         v-for="(unit, idx) in items"
      //-         :key="idx"
      //-         lg=4 md=6 sm=6 cols=12 xs="12"
      //-       ).py-10.px-6
      //-         v-card.sdo-card(height="100%" width="100%").px-5.py-2
      //-           v-card-text.d-flex.flex-column
      //-             v-chip(
      //-               style="position: absolute; left: -3px; top: 0" right="0"
      //-               color="secondary" small
      //-             ): strong {{ (slideIdx * breakpointCount) + idx + 1 }}
      //-             p.title: strong {{ unit.title }}
      //-             v-spacer
      //-             span.strong.text-end: strong {{ $tc('hours', unit.duration) }}
          //- v-timeline(
          //-   dense
          //- )
          //-   v-timeline-item(
          //-     v-for="unit in i"
          //-     :key="unit.id"
          //-     color="secondary"
          //-   )
          //-     template(#icon)
          //-       strong.white--text {{ unit.idx }}
          //-     v-card.sdo-card
          //-       v-card-text
          //-         p.title {{ unit.title }}
          //-         strong {{ $tc('hours', unit.duration) }}
</template>

<script>
export default {
  props: {
    course: { type: Object, required: true },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    // reduceUnits() {
    //   return this.course.units.reduce((acc, item, idx) => {
    //     acc[(idx % 2)].push({ ...item, idx: idx + 1 });
    //     return acc;
    //   }, [[], []]);
    // },
  },
};
</script>
